import { forwardRef, useCallback } from "react";
import { useSnackbar, SnackbarContent } from "notistack";
import {
  Typography,
  Card,
  CardActions,
  IconButton,
  Stack,
  Button,
  Box
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { ToastProps } from "./interface";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { sxConfig } from "./Style";

const Toast = forwardRef<HTMLDivElement, ToastProps>(
  (
    {
      id,
      title,
      message = "",
      messageAction,
      variant = "info",
      viewInfo,
      viewInfoOnSamePage,
      InfoOnSamePageName,
      styleConfig = {}
    },
    ref
  ) => {
    const { closeSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const { mainContainerWidth = 380, mainTitleFlexGrow = 0 } = styleConfig;

    const handleDismiss = useCallback(
      () => closeSnackbar(id),
      [id, closeSnackbar]
    );

    return (
      <SnackbarContent ref={ref}>
        <Card sx={sxConfig.mainContainer(mainContainerWidth, variant)}>
          <CardActions sx={sxConfig.titleMainContainer}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              width={"100%"}
            >
              <Box
                display="flex"
                justifyContent="center"
                {...sxConfig.mainTitle(mainTitleFlexGrow)}
              >
                <Typography variant="subtitle2">{title}</Typography>
              </Box>
              <IconButton onClick={handleDismiss} aria-label="Close Toast">
                <Close />
              </IconButton>
            </Stack>
          </CardActions>
          {message && (
            <Stack sx={sxConfig.messageContainer}>
              <Typography gutterBottom variant="body2">
                {message}
              </Typography>

              {messageAction}
            </Stack>
          )}
          <Stack sx={sxConfig.viewInfoContainer}>
            {viewInfo && (
              <a href={viewInfo} target="_blank" rel="noreferrer">
                <Button>{t("reports.viewInfo")}</Button>
              </a>
            )}
          </Stack>
          <Stack sx={sxConfig.generateReportContainer}>
            {viewInfoOnSamePage && (
              <Link to={viewInfoOnSamePage} aria-label={"open notification"}>
                <Button data-testid="generatedReports">
                  {InfoOnSamePageName || t("reports.generatedReportsSection")}
                </Button>
              </Link>
            )}
          </Stack>
        </Card>
      </SnackbarContent>
    );
  }
);

Toast.displayName = "Toast";

export default Toast;
